const data = {
  id: 1,
  title: 'Listen and choose the picture described.',
  subTitle: 'Nghe và chọn hình ảnh được mô tả.',
  audioUrl: 'https://cloud.softech.cloud/storage/Data/Sentences/3fd03523-96f4-4aaa-a600-d9fc117cfb5d.mp3',
  question: '',
  answers: [
    { id: 1, answer: 'https://cloud.softech.vn/storage/SachSo/Images/Vocabulary/SGK/write.png', isCorrect: false },
    { id: 2, answer: 'https://cloud.softech.vn/storage/SachSo/Images/Vocabulary/SGK/read.png', isCorrect: true },
    { id: 3, answer: 'https://cloud.softech.vn/storage/SachSo/Images/Vocabulary/SGK/listen.png', isCorrect: false },
  ],
  settings: {
    answers: {
      // direction: 'horizontal',
      // direction: 'vertical',
      bulletType: 'character',
      imageAnswers: true, // True là vẽ hình, False hoặc không có là vẽ Button.
      columnImageAnswers: 3, // Số cột và hình nên đi cặp cùng nhau.
    },
  },
};

export default data;
